export const mt5Tutorials = [
  {
    slug: 'mt5-download-install',
    group: 'start',
    title: 'วิธีดาวน์โหลดและติดตั้ง MT5',
    minutes: 5,
    desc: 'ดาวน์โหลดตัวติดตั้ง MT5 จากโบรกเกอร์ของคุณ แล้วติดตั้งพร้อมล็อกอินครั้งแรกให้เสร็จในขั้นตอนเดียว',
    steps: [
      'เข้าเว็บไซต์โบรกเกอร์ เลือกหน้าดาวน์โหลดแพลตฟอร์ม แล้วเลือก MetaTrader 5 ให้ตรงกับระบบปฏิบัติการ',
      'เปิดไฟล์ติดตั้ง กด Next ตามค่าเริ่มต้นจนจอโปรแกรมขึ้นมา',
      'เลือก File > Login to Trade Account กรอกเลขบัญชี รหัสผ่าน และเลือกเซิร์ฟเวอร์ให้ถูกต้อง',
    ],
    note: 'MT5 กับ MT4 เป็นคนละโปรแกรม ตัวติดตั้งของ MT4 ใช้เปิดบัญชี MT5 ไม่ได้ จึงต้องโหลดตัวที่ระบุว่า MetaTrader 5 เท่านั้น',
  },
  {
    slug: 'mt5-login-account',
    group: 'start',
    title: 'วิธีเข้าสู่ระบบบัญชีซื้อขาย MT5',
    minutes: 5,
    desc: 'บัญชี MT5 ต้องมาจากโบรกเกอร์ที่รองรับแพลตฟอร์มนี้ การล็อกอินใช้เลขบัญชี รหัสผ่าน และชื่อเซิร์ฟเวอร์',
    steps: [
      'เปิด MT5 แล้วไปที่เมนู File > Login to Trade Account',
      'กรอกเลขบัญชีและรหัสผ่าน จากนั้นเลือกเซิร์ฟเวอร์ที่ขึ้นต้นด้วยชื่อโบรกเกอร์ของคุณ',
      'ตรวจสถานะมุมขวาล่างว่าขึ้น connected พร้อมตัวเลข ping ก่อนเริ่มใช้งาน',
    ],
    note: 'ถ้าโบรกเกอร์มีทั้งเซิร์ฟเวอร์แบบ Netting และ Hedging ต้องเลือกรุ่นบัญชีให้ตรงกับที่สมัครไว้ จึงจะล็อกอินผ่าน',
  },
  {
    slug: 'mt5-screen-overview',
    group: 'start',
    title: 'ส่วนต่าง ๆ บนหน้าจอ MT5 มีอะไรบ้าง',
    minutes: 6,
    desc: 'หน้าจอ MT5 คล้าย MT4 แต่เปลี่ยนชื่อบางส่วนและเพิ่มแท็บเครื่องมือวิเคราะห์เข้ามาในหน้าต่าง Toolbox',
    steps: [
      'Market Watch อยู่มุมซ้ายบน ใช้ดูราคาและเลือกสินทรัพย์ที่จะเปิดกราฟ',
      'Navigator อยู่มุมซ้ายล่าง เก็บอินดิเคเตอร์และเครื่องมือวิเคราะห์ทั้งหมด',
      'Toolbox ด้านล่างแทน Terminal ของ MT4 และมีแท็บเพิ่มอย่าง Economic Calendar กับ Overview',
    ],
    note: 'MT5 เรียกหน้าต่างด้านล่างว่า Toolbox ไม่ใช่ Terminal ถ้าหาไม่เจอให้ไปที่ View > Toolbox',
  },
  {
    slug: 'mt5-market-watch',
    group: 'start',
    title: 'วิธีใช้งานหน้าต่าง Market Watch ใน MT5',
    minutes: 6,
    desc: 'Market Watch ของ MT5 รองรับสินทรัพย์หลากหลายกว่า MT4 ทั้ง Forex หุ้น และฟิวเจอร์ส อยู่ในหน้าต่างเดียว',
    steps: [
      'กด Ctrl+M หรือไปที่ View > Market Watch เพื่อเปิดหน้าต่างนี้',
      'คลิกขวาแล้วเลือก Symbols เพื่อเปิดรายการสินทรัพย์ แยกตามหมวด Forex, Stocks, Indices',
      'ดับเบิลคลิกสินทรัพย์ที่ต้องการเพื่อเพิ่มเข้าสู่รายการที่ติดตาม',
    ],
    note: 'สินทรัพย์บางหมวดจะแสดงก็ต่อเมื่อโบรกเกอร์เปิดให้เทรด ถ้ารายการว่างไม่ใช่โปรแกรมเสีย แต่คือโบรกเกอร์ไม่ได้ให้บริการส่วนนั้น',
  },
  {
    slug: 'mt5-change-timeframe',
    group: 'chart',
    title: 'วิธีเปลี่ยนกรอบเวลาใน MT5',
    minutes: 5,
    desc: 'MT5 มีกรอบเวลาให้เลือกถึง 21 แบบ รวมช่วงกลางอย่าง M2 ถึง M12 และ H2 ถึง H12 ที่ MT4 ไม่มี',
    steps: [
      'กดปุ่มกรอบเวลาบนแถบเครื่องมือ หรือไปที่เมนู Charts > Timeframe',
      'เลือกกรอบที่ต้องการ เช่น M20 สำหรับดูจังหวะสั้น หรือ H4 สำหรับดูแนวโน้มหลัก',
      'ตรวจชื่อกรอบเวลามุมซ้ายบนของกราฟอีกครั้งก่อนวาดเส้นหรือตั้งอินดิเคเตอร์',
    ],
    note: 'กรอบเวลายิ่งถี่ ยิ่งเกิดสัญญาณหลอกบ่อยขึ้น มือใหม่ควรเริ่มที่ H1 ขึ้นไปก่อน แล้วค่อยลดลงมาเมื่อเข้าใจโครงสร้างราคาแล้ว',
  },
  {
    slug: 'mt5-add-trendline',
    group: 'chart',
    title: 'วิธีเพิ่มเส้นแนวโน้มใน MT5',
    minutes: 6,
    desc: 'วาดเส้นแนวโน้มบน MT5 ได้จากแถบเครื่องมือหรือเมนู Insert > Objects เช่นเดียวกับ MT4',
    steps: [
      'คลิกไอคอนเส้นทแยงบนแถบเครื่องมือ หรือไปที่ Insert > Objects > Trendline',
      'คลิกจุดเริ่มต้นแล้วลากไปยังจุดสิ้นสุด ปล่อยเมาส์เพื่อวางเส้นบนกราฟ',
      'ดับเบิลคลิกที่เส้นเพื่อปรับสี ความหนา และเลือกขยายเส้นต่อเนื่องได้ในแท็บ Parameters',
    ],
    note: 'MT5 มีตัวเลือกขยายเส้นอัตโนมัติ (Ray) ที่ต่างจาก MT4 เล็กน้อย ควรเลือกให้เหมาะกับว่าจะใช้เส้นเป็นแนวรับหรือกรอบแนวโน้ม',
  },
  {
    slug: 'mt5-add-text',
    group: 'chart',
    title: 'วิธีเพิ่มข้อความลงในกราฟ MT5',
    minutes: 4,
    desc: 'ข้อความบนกราฟใช้จดเหตุผลการเข้า จุดStop Loss หรือระดับราคาที่รออยู่ เป็นบันทึกส่วนตัวก่อนกดออเดอร์',
    steps: [
      'ไปที่ Insert > Text หรือกดปุ่มตัวอักษร A บนแถบเครื่องมือ',
      'คลิกตำแหน่งที่ต้องการแล้วพิมพ์ข้อความ กด Enter เพื่อยืนยัน',
      'ดับเบิลคลิกข้อความเพื่อแก้ไข หรือกด Delete หลังเลือกข้อความเพื่อลบทิ้ง',
    ],
    note: 'ข้อความผูกกับกรอบเวลาและคู่เงินของกราฟนั้น ถ้าเปิดกราฟคู่อื่นจะไม่เห็นข้อความนี้ ให้ตรวจกรอบเวลาและคู่เงินก่อนสรุปว่าหาย',
  },
  {
    slug: 'mt5-objects-list',
    group: 'chart',
    title: 'วิธีเปิดรายการวัตถุใน MT5',
    minutes: 4,
    desc: 'รายการวัตถุช่วยให้เห็นทุกเส้นและข้อความบนกราฟในที่เดียว ใช้ลบหรือซ่อนของที่ไม่ต้องการได้เร็ว',
    steps: [
      'ไปที่เมนู Charts > Objects List หรือกด Ctrl+B',
      'เลือกวัตถุที่ต้องการแล้วกด Edit เพื่อแก้ไข หรือ Delete เพื่อลบออกจากกราฟ',
      'ถ้าต้องการซ่อนชั่วคราว ให้ยกเลิกเครื่องหมายในคอลัมน์ที่แสดงสถานะการมองเห็น',
    ],
    note: 'ก่อนลบทั้งรายการ ควรตรวจว่ามีเส้นที่ยังใช้เป็นแนวรับแนวต้านอยู่หรือไม่ เพราะการลบในหน้านี้ไม่สามารถย้อนกลับได้',
  },
  {
    slug: 'mt5-add-indicator',
    group: 'tools',
    title: 'วิธีเพิ่มอินดิเคเตอร์ใน MT5',
    minutes: 6,
    desc: 'MT5 มีอินดิเคเตอร์ในตัวมากกว่า MT4 เพิ่มได้จาก Navigator หรือเมนู Insert > Indicators',
    steps: [
      'ไปที่ Insert > Indicators แล้วเลือกหมวด เช่น Trend, Oscillators หรือ Volumes',
      'เลือกอินดิเคเตอร์ที่ต้องการ หน้าต่างตั้งค่าจะเปิดขึ้นก่อนวางบนกราฟ',
      'กด OK อินดิเคเตอร์จะแสดงในกราฟหรือหน้าต่างย่อยตามประเภทของมัน',
    ],
    note: 'ชื่ออินดิเคเตอร์บางตัวใน MT5 เหมือน MT4 แต่พารามิเตอร์เริ่มต้นอาจต่างกัน ให้ตรวจค่าในแท็บ Inputs ก่อนใช้สัญญาณ',
  },
  {
    slug: 'mt5-indicator-settings',
    group: 'tools',
    title: 'วิธีตั้งค่าอินดิเคเตอร์ใน MT5',
    minutes: 5,
    desc: 'ปรับค่า Period สี และระดับสัญญาณของอินดิเคเตอร์ได้จากหน้าต่าง Properties โดยไม่ต้องลบแล้วเพิ่มใหม่',
    steps: [
      'กด Ctrl+I เพื่อเปิดรายการอินดิเคเตอร์ที่ใช้บนกราฟ',
      'เลือกตัวที่ต้องการแล้วกด Properties',
      'แก้ค่าในแท็บ Inputs และปรับสีหรือความหนาของเส้นในแท็บ Colors แล้วกด OK',
    ],
    note: 'ถ้าปรับค่าแล้วสัญญาณเปลี่ยนมากจนจำกราฟเดิมไม่ได้ ให้บันทึกเทมเพลตแยกไว้ เพราะค่าที่ดีกับกรอบเวลาหนึ่งอาจใช้กับอีกกรอบไม่ได้',
  },
  {
    slug: 'mt5-find-tools',
    group: 'tools',
    title: 'วิธีค้นหาเครื่องมือหรืออินดิเคเตอร์ใน MT5',
    minutes: 5,
    desc: 'MT5 มีเครื่องมือเยอะจนหาชื่อไม่เจอ ใช้ช่องค้นหาใน Navigator และหน้าต่าง Market เพื่อหาได้เร็วขึ้น',
    steps: [
      'เปิด Navigator ด้วย Ctrl+N แล้วพิมพ์ชื่ออินดิเคเตอร์ในช่องค้นหาด้านบน',
      'ถ้าเป็นเครื่องมือวิเคราะห์ ให้ดูในแท็บ Navigator > Indicators หรือไปที่ Insert > Indicators',
      'สำหรับสินทรัพย์ ให้เปิด Market Watch แล้วใช้ช่องค้นหาในหน้าต่าง Symbols',
    ],
    note: 'อินดิเคเตอร์ที่โหลดจากภายนอกจะอยู่ใต้หัวข้อ Custom ไม่ใช่ Indicators จึงควรตรวจทั้งสองที่ก่อนสรุปว่าหารายการไม่เจอ',
  },
  {
    slug: 'mt5-open-close-order',
    group: 'order',
    title: 'วิธีเปิดและปิดคำสั่งซื้อขายใน MT5',
    minutes: 9,
    desc: 'หน้าต่าง New Order ของ MT5 แยกการเลือกประเภทคำสั่งชัดเจนกว่า MT4 และปิดออเดอร์ได้จากแท็บ Trade',
    steps: [
      'กด F9 หรือคลิกขวาที่กราฟเลือก Trading > New Order',
      'เลือก Symbol, Volume และประเภทคำสั่ง (Market Execution หรือ Pending Order) แล้วกด Buy หรือ Sell',
      'เมื่อต้องการปิด ให้เปิดแท็บ Trade ใน Toolbox คลิกขวาที่ออเดอร์แล้วเลือก Close Position',
    ],
    note: 'บัญชีแบบ Netting จะรวมออเดอร์ทิศเดียวกันเป็นสถานะเดียว การปิดจึงปิดทั้งสถานะ ไม่ใช่ปิดทีละรายการเหมือนบัญชี Hedging',
  },
  {
    slug: 'mt5-set-sl-tp',
    group: 'order',
    title: 'วิธีตั้ง Stop Loss และ Take Profit ใน MT5',
    minutes: 6,
    desc: 'Stop Loss และ Take Profit ใน MT5 กรอกเป็นระดับราคาในหน้าต่าง New Order หรือแก้ไขภายหลังได้จากแท็บ Trade',
    steps: [
      'ในหน้าต่าง New Order กรอกช่อง Stop Loss และ Take Profit ก่อนกดยืนยันคำสั่ง',
      'ตรวจระยะขั้นต่ำที่ระบบกำหนด ถ้าใส่ใกล้ราคาปัจจุบันเกินไปจะขึ้นข้อความ Invalid stops',
      'ถ้าเปิดออเดอร์แล้ว ให้คลิกขวาที่สถานะเลือก Modify Position เพื่อเติมหรือเลื่อนจุดทั้งสอง',
    ],
    note: 'การเลื่อน Stop Loss เพื่อลดความเสี่ยงทำได้ แต่ควรเลื่อนตามโครงสร้างราคา ไม่ใช่เลื่อนหนีการขาดทุนด้วยอารมณ์',
  },
  {
    slug: 'mt5-trade-history',
    group: 'order',
    title: 'วิธีดูประวัติการซื้อขายใน MT5',
    minutes: 5,
    desc: 'ประวัติการเทรดใน MT5 อยู่ที่แท็บ History ของ Toolbox และมีรายละเอียดค่าคอมมิชชันกับสวอปแยกให้ดู',
    steps: [
      'เปิดแท็บ History ในหน้าต่าง Toolbox ด้านล่าง',
      'คลิกขวาในช่วงว่างเลือก Period เพื่อกำหนดช่วงวันที่ที่ต้องการดู',
      'คลิกขวารายการแล้วเลือก Save as Report หากต้องการเก็บไฟล์ไว้ทบทวน',
    ],
    note: 'ถ้าดูเฉพาะออเดอร์ที่ปิดแล้วไม่เห็นรายการ ให้เปลี่ยนตัวกรองจาก Positions เป็น Orders หรือ Deals ตามสิ่งที่ต้องการตรวจ',
  },
  {
    slug: 'mt5-chart-not-showing',
    group: 'trouble',
    title: 'วิธีแก้ปัญหา MT5 ไม่แสดงกราฟ',
    minutes: 5,
    desc: 'กราฟ MT5 ว่างหรือโหลดค้าง ส่วนใหญ่มาจากการเชื่อมต่อหรือจำนวนแท็บกราฟที่เปิดไว้มากเกินไป',
    steps: [
      'ตรวจสถานะเชื่อมต่อมุมขวาล่าง ถ้าหลุดให้ล็อกอินใหม่ผ่าน File > Login to Trade Account',
      'คลิกขวาที่กราฟเลือก Refresh แล้วรอให้ราคาโหลดย้อนหลังเสร็จ',
      'ถ้ายังว่าง ให้ปิดกราฟที่ไม่ใช้ ลดจำนวนแท็บแล้วเปิดใหม่ผ่าน File > New Chart',
    ],
    note: 'สินทรัพย์ที่โบรกเกอร์ปิดให้เทรดจะไม่แสดงกราฟใหม่ ให้ตรวจรายการ Symbols ว่าสินทรัพย์นั้นยังเปิดให้เทรดอยู่หรือไม่',
  },
  {
    slug: 'mt5-find-indicator-trouble',
    group: 'trouble',
    title: 'วิธีค้นหาอินดิเคเตอร์ที่ต้องการใน MT5',
    minutes: 5,
    desc: 'อินดิเคเตอร์ที่หาไม่เจออาจอยู่ใต้หมวด Custom หรือยังไม่ได้ติดตั้งลงในโฟลเดอร์ของแพลตฟอร์ม',
    steps: [
      'เปิด Navigator ด้วย Ctrl+N แล้วพิมพ์ชื่อบางส่วนในช่องค้นหา',
      'ตรวจทั้งหัวข้อ Indicators และ Custom เพราะอินดิเคเตอร์ที่โหลดมาจะอยู่ใต้ Custom',
      'ถ้าไม่มีจริง ให้ตรวจว่าไฟล์ถูกวางในโฟลเดอร์ MQL5 > Indicators ของข้อมูลแพลตฟอร์ม แล้วรีสตาร์ตโปรแกรม',
    ],
    note: 'อินดิเคเตอร์ที่เขียนสำหรับ MT4 ใช้กับ MT5 ไม่ได้ เพราะใช้ภาษาคนละตัว ต้องหาเวอร์ชัน MT5 แยก',
  },
  {
    slug: 'mt5-cannot-login',
    group: 'trouble',
    title: 'ทำไมไม่สามารถเข้าสู่ระบบ MT5 ได้',
    minutes: 5,
    desc: 'ล็อกอิน MT5 ไม่ผ่านมักมาจากเซิร์ฟเวอร์ไม่ตรง รหัสผ่านผิด หรือบัญชีถูกสร้างสำหรับแพลตฟอร์มอื่น',
    steps: [
      'ตรวจว่าเลือกเซิร์ฟเวอร์ตรงกับอีเมลของโบรกเกอร์ และเป็นเซิร์ฟเวอร์ของ MT5 ไม่ใช่ MT4',
      'พิมพ์รหัสผ่านใหม่โดยตรวจตัวพิมพ์ใหญ่เล็ก และปิด Caps Lock',
      'ถ้ายังไม่ผ่าน ให้ติดต่อโบรกเกอร์เพื่อตรวจสถานะบัญชีหรือขอรีเซ็ตรหัสผ่าน',
    ],
    note: 'บัญชีที่เปิดไว้สำหรับ MT4 ไม่สามารถใช้ล็อกอิน MT5 ได้โดยตรง ต้องสอบถามโบรกเกอร์ว่าต้องเปิดบัญชีใหม่หรือไม่',
  },
];